import { Button } from "antd";
import React from "react";
import { QuestionAnswers } from "../../../../Interface/Index";

interface QuestionActionButtonsProps {
  activeQuestionIndex: number;
  currentSessionQuestions: any[];
  handleNext: () => void;
  handleBack: () => void;
  currentSessionQuestionAnswers: QuestionAnswers[];
  isRoundFinished: boolean;
}

const QuestionActionButtons: React.FC<QuestionActionButtonsProps> = ({
  activeQuestionIndex,
  currentSessionQuestions,
  handleBack,
  handleNext,
  currentSessionQuestionAnswers,
  isRoundFinished,
}) => {
  const getButtonText = () => {
    const currentQuestion = currentSessionQuestions[activeQuestionIndex];
    const questionType = currentQuestion?.type;
    const answer =
      questionType.toLowerCase() === "fileUpload"
        ? currentSessionQuestionAnswers[activeQuestionIndex]?.fileUrl
        : currentSessionQuestionAnswers[activeQuestionIndex]?.answer;

    if (
      isRoundFinished ||
      (currentQuestion?.responses && currentQuestion.responses.length > 0) ||
      !answer
    ) {
      return "Next";
    }
    return "Submit";
  };

  return (
    <div className="button-group">
      <Button
        className="back-button"
        onClick={handleBack}
        disabled={activeQuestionIndex === 0}
      >
        Back
      </Button>
      <Button
        type="primary"
        className="proceed-button"
        onClick={handleNext}
        disabled={activeQuestionIndex >= currentSessionQuestions.length}
      >
        {getButtonText()}
      </Button>
    </div>
  );
};

export default QuestionActionButtons;
